function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16,8a8,8,0,1,0,8,8A8,8,0,0,0,16,8Zm0,11.25A3.25,3.25,0,1,1,19.25,16,3.26,3.26,0,0,1,16,19.25Z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.49,7.51A12,12,0,1,0,28,16,12,12,0,0,0,24.49,7.51ZM16,24a8,8,0,1,1,8-8A8,8,0,0,1,16,24Z",
  fill: "#c63c3c"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 3.25,
  fill: "#33ba69"
});

var SvgMapMarkerAlarmIcon = function SvgMapMarkerAlarmIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapMarkerAlarmIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map_marker_alarm_icon.c0769feb.svg";
export { ForwardRef as ReactComponent };